import React from "react";
import "./Cards.css";
import { Link } from "react-router-dom";
import CardItem from "./CardItem";

function ProjectItems() {
  return (
    <>
      <div className="cards__container">
        <div className="cards__wrapper">
            <Link to="https://devpost.com/software/successibility">
              <CardItem
                src={require("./images/successibility.jpg")}
                text="Successibility"
                label="BrickHacksX (February 2024)"
                path="https://devpost.com/software/successibility"
              />
            </Link>
          <Link to="https://www.arkheproject.org">
            <CardItem
              src={require("./images/arkhe.png")}
              text="ARKHE"
              label="Internship (May-August 2023)"
              path="https://www.arkheproject.org"
            />
          </Link>
          <Link to="https://people.rit.edu/kc4509/235/project3/">
            <CardItem
              src={require("./images/jsGame.png")}
              text="Kingdom of Doors"
              label="Project (April-May 2023)"
              path="https://people.rit.edu/kc4509/235/project3/"
            />
          </Link>
          <Link to="https://devpost.com/software/shapeit">
            <CardItem
              src={require("./images/shapeIt.jpg")}
              text="ShapeIt!"
              label="BrickHacks9 (February 2023)"
              path="https://devpost.com/software/shapeit"
            />
          </Link>
          <Link to="https://igm-202-2235.github.io/project-1-kc4509/checkpoint_3/">
            <CardItem
              src={require("./images/unity.png")}
              text="Crossy Road Gone Wrong (WIP)"
              label="Project (March 2024)"
              path="https://igm-202-2235.github.io/project-1-kc4509/checkpoint_3/"
            />
          </Link>
          <CardItem
            src={require("./images/database.png")}
            text="Genshin Character Database (Private Github)"
            label="Project (February 2024)"
            path="/projects"
          />
        </div>
      </div>
    </>
  );
}

export default ProjectItems;
